'use strict';
module.exports = require('./Button.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/button/index.js
// module id = 3
// module chunks = 1